import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickStats = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
      {stats?.map((stat, index) => (
        <div
          key={index}
          className="card hover:shadow-xl transition-all duration-250"
        >
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${stat?.bgColor}`}>
              <Icon name={stat?.icon} size={24} color={stat?.iconColor} />
            </div>
            {stat?.trend && (
              <div className={`flex items-center gap-1 text-xs font-medium ${
                stat?.trendDirection === 'up' ? 'text-success' : 'text-error'
              }`}>
                <Icon 
                  name={stat?.trendDirection === 'up' ? 'TrendingUp' : 'TrendingDown'} 
                  size={14} 
                />
                {stat?.trend}
              </div>
            )}
          </div>

          <div>
            <p className="text-3xl font-bold text-foreground data-text mb-1">
              {stat?.value}
            </p>
            <p className="text-sm text-muted-foreground">{stat?.label}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default QuickStats;